/**
 * Bundle Selector — Vollständige Logik
 * Step 2: Card Selection + Slot Update via Modal
 * Step 3: Add-to-Cart via Shopify Cart API + Cart Drawer
 * Vanilla JS, kein jQuery, kein Framework.
 */

(function () {
  'use strict';

  var SELECTOR = {
    wrapper: '[data-bundle-selector]',
    card: '[data-bundle-card]',
    openModal: '[data-open-bundle-modal]',
    closeModal: '[data-close-bundle-modal]',
    modal: '#bundleModal',
    modalItem: '.bundle-modal__item',
    slot: '[data-slot-index]',
    slotThumb: '[data-slot-thumb]',
    slotName: '[data-slot-name]',
    cta: '[data-bundle-add-to-cart]',
    selectedClass: 'is-selected',
    loadingClass: 'is-loading',
  };

  /* Aktuell bearbeiteter Slot */
  var currentSlot = null;

  function initBundleSelector() {
    var wrappers = document.querySelectorAll(SELECTOR.wrapper);
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      initCardSelection(wrapper);
      initModal(wrapper);
      initModalItemSelection(wrapper);
      initRandomSlots(wrapper);
      initAddToCart(wrapper);
      updateCTAPrice(wrapper);
    });
  }

  /* ========================
     Card Selection (Einzel vs Bundle)
     ======================== */
  function initCardSelection(wrapper) {
    var cards = wrapper.querySelectorAll(SELECTOR.card);
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('button')) return;

        cards.forEach(function (c) {
          c.classList.remove(SELECTOR.selectedClass);
        });
        card.classList.add(SELECTOR.selectedClass);

        updateCTAPrice(wrapper);
      });
    });
  }

  /* ========================
     CTA Preis-Update
     ======================== */
  function updateCTAPrice(wrapper) {
    var cta = wrapper.querySelector(SELECTOR.cta);
    if (!cta) return;

    var selectedCard = wrapper.querySelector('.' + SELECTOR.selectedClass);
    if (!selectedCard) return;

    var priceEl = selectedCard.querySelector('.pd__price-now');
    if (priceEl) {
      var ctaText = cta.getAttribute('data-cta-label') || cta.textContent.split('~')[0].trim();
      cta.setAttribute('data-cta-label', ctaText);
      cta.textContent = ctaText + ' ~ ' + priceEl.textContent.trim();
    }
  }

  /* ========================
     Modal Open/Close
     ======================== */
  function initModal(wrapper) {
    var modal = wrapper.querySelector(SELECTOR.modal);
    if (!modal) return;

    /* --- Open --- */
    var openButtons = wrapper.querySelectorAll(SELECTOR.openModal);
    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();

        var slotEl = btn.closest(SELECTOR.slot);
        if (slotEl) {
          currentSlot = slotEl;

          /* Aktuell gewählte Variante im Modal markieren */
          var currentVariantId = slotEl.getAttribute('data-variant-id');
          highlightModalItem(modal, currentVariantId);
        }

        openModalFn(modal);
      });
    });

    /* --- Close via Overlay + X-Button --- */
    var closeButtons = modal.querySelectorAll(SELECTOR.closeModal);
    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeModalFn(modal);
      });
    });

    /* --- Close via Escape --- */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        closeModalFn(modal);
      }
    });
  }

  function openModalFn(modal) {
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModalFn(modal) {
    modal.hidden = true;
    document.body.style.overflow = '';
    currentSlot = null;
  }

  function highlightModalItem(modal, variantId) {
    var items = modal.querySelectorAll(SELECTOR.modalItem);
    items.forEach(function (item) {
      item.classList.remove('is-active');
      if (item.getAttribute('data-variant-id') === variantId) {
        item.classList.add('is-active');
      }
    });
  }

  /* ========================
     Modal Item Selection → Slot Update
     ======================== */
  function initModalItemSelection(wrapper) {
    var modal = wrapper.querySelector(SELECTOR.modal);
    if (!modal) return;

    var items = modal.querySelectorAll(SELECTOR.modalItem);
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        if (item.disabled) return;
        if (!currentSlot) return;

        /* Daten vom gewählten Produkt auslesen */
        var variantId = item.getAttribute('data-variant-id');
        var title = item.getAttribute('data-title');
        var thumb = item.getAttribute('data-thumb');

        /* Slot aktualisieren */
        currentSlot.setAttribute('data-variant-id', variantId);

        var nameEl = currentSlot.querySelector(SELECTOR.slotName);
        if (nameEl) nameEl.textContent = title;

        var thumbEl = currentSlot.querySelector(SELECTOR.slotThumb);
        if (thumbEl) {
          thumbEl.src = thumb;
          thumbEl.alt = title;
        }

        /* Modal schließen */
        closeModalFn(modal);
      });
    });
  }

  /* ========================
     Random Slot Pre-Fill (Slot 2+ mit zufälligem Produkt)
     ======================== */
  function initRandomSlots(wrapper) {
    var allSlots = wrapper.querySelectorAll(SELECTOR.slot);
    if (!allSlots.length) return;

    var modal = wrapper.querySelector(SELECTOR.modal);
    if (!modal) return;

    var currentVariantId = wrapper.getAttribute('data-current-variant-id');
    var allItems = modal.querySelectorAll(SELECTOR.modalItem);

    /* Alle Modal-Items sammeln, die NICHT das aktuelle Produkt sind */
    var others = [];
    allItems.forEach(function (item) {
      if (item.getAttribute('data-variant-id') !== currentVariantId) {
        others.push({
          variantId: item.getAttribute('data-variant-id'),
          title: item.getAttribute('data-title'),
          thumb: item.getAttribute('data-thumb'),
        });
      }
    });

    if (!others.length) return;

    /* Fisher-Yates Shuffle */
    for (var i = others.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = others[i];
      others[i] = others[j];
      others[j] = tmp;
    }

    /* Nur Slots mit Index > 1 randomisieren — Slot 1 bleibt IMMER das aktuelle Produkt */
    var pickIdx = 0;
    allSlots.forEach(function (slot) {
      var slotIndex = slot.getAttribute('data-slot-index');
      if (slotIndex === '1') return; /* Slot 1 = aktuelles Produkt, NIE ändern */

      var pick = others[pickIdx % others.length];
      pickIdx++;

      slot.setAttribute('data-variant-id', pick.variantId);

      var nameEl = slot.querySelector(SELECTOR.slotName);
      if (nameEl) nameEl.textContent = pick.title;

      var thumbEl = slot.querySelector(SELECTOR.slotThumb);
      if (thumbEl) {
        thumbEl.src = pick.thumb;
        thumbEl.alt = pick.title;
      }
    });
  }

  /* ========================
     Add to Cart + Open Drawer
     ======================== */
  function initAddToCart(wrapper) {
    var cta = wrapper.querySelector(SELECTOR.cta);
    if (!cta) return;

    cta.addEventListener('click', function (e) {
      e.preventDefault();
      if (cta.classList.contains(SELECTOR.loadingClass)) return;

      var selectedCard = wrapper.querySelector('.' + SELECTOR.selectedClass);
      if (!selectedCard) return;

      var multiplier = parseInt(selectedCard.getAttribute('data-multiplier'), 10) || 1;

      /* Variant IDs sammeln */
      var items = [];

      if (multiplier === 1) {
        /* Einzelprodukt: aktuelle Variante der Seite */
        var currentVariantId = wrapper.getAttribute('data-current-variant-id');
        if (currentVariantId) {
          items.push({ id: parseInt(currentVariantId, 10), quantity: 1 });
        }
      } else {
        /* Bundle: alle Slots auslesen */
        var slots = selectedCard.querySelectorAll(SELECTOR.slot);
        slots.forEach(function (slot) {
          var vid = slot.getAttribute('data-variant-id');
          if (vid) {
            items.push({ id: parseInt(vid, 10), quantity: 1 });
          }
        });
      }

      if (!items.length) return;

      /* Loading State */
      cta.classList.add(SELECTOR.loadingClass);
      var originalText = cta.textContent;
      cta.textContent = 'Wird hinzugefügt...';

      /* Section ID für Cart Drawer ermitteln */
      var sectionId = getSectionId();

      /* Cart API Call mit Section Rendering */
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items, sections: sectionId }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart error');
          return response.json();
        })
        .then(function (data) {
          /* Cart Drawer Content updaten + öffnen */
          openCartDrawer(data.sections, sectionId);
        })
        .catch(function (err) {
          console.error('Bundle Add-to-Cart Error:', err);
          alert('Fehler beim Hinzufügen. Bitte versuche es erneut.');
        })
        .finally(function () {
          cta.classList.remove(SELECTOR.loadingClass);
          cta.textContent = originalText;
        });
    });
  }

  /* ========================
     Section ID ermitteln (Horizon Theme)
     ======================== */
  function getSectionId() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return '';

    var section = drawer.closest('[id^="shopify-section"]');
    if (section) {
      /* "shopify-section-" prefix entfernen → gibt die reine Section ID */
      return section.id.replace('shopify-section-', '');
    }
    return '';
  }

  /* ========================
     Cart Drawer öffnen (Horizon Theme)
     ======================== */
  function openCartDrawer(sections, sectionId) {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) {
      window.location.href = '/cart';
      return;
    }

    /* Wenn Section-HTML vorhanden: Drawer Content aktualisieren */
    if (sections && sectionId && sections[sectionId]) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(sections[sectionId], 'text/html');
      var newDrawer = doc.querySelector('cart-drawer-component');

      if (newDrawer) {
        drawer.innerHTML = newDrawer.innerHTML;
      }
    }

    /* Dialog mit showModal() öffnen (Horizon nutzt <dialog>) */
    var dialog = drawer.querySelector('dialog');
    if (dialog) {
      if (dialog.open) dialog.close();
      dialog.showModal();
    }
  }

  /* Getter für currentSlot (Kompatibilität) */
  window.__bundleSelector = {
    getCurrentSlot: function () {
      return currentSlot;
    },
  };

  /* Init wenn DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleSelector);
  } else {
    initBundleSelector();
  }
})();